import { render, staticRenderFns } from "./VaVerification.vue?vue&type=template&id=1b300bd6&scoped=true&"
import script from "./VaVerification.vue?vue&type=script&lang=js&"
export * from "./VaVerification.vue?vue&type=script&lang=js&"
import style0 from "./VaVerification.vue?vue&type=style&index=0&id=1b300bd6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b300bd6",
  null
  
)

export default component.exports